export const topbar = {
  searchPlaceholder: '搜尋任務、紀錄、模板...',
  profile: '個人資料',
  settings: '設定',
  logout: '登出',
};
